export default {
  proxy: "",
  currentEnv: "dev",
  environment: {
    dev: {
      azure: {

      },
      api: {
        hostname: "https://tkofapim.azure-api.net",
        clientId: "dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2",
        scope: "openid dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2  profile",
        personalLoginUrl: "https://thekitchenofthefuture.b2clogin.com/thekitchenofthefuture.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC",
        subscriptionkey: "964bf762168d4403a69040dc14858380",
        base: {
          recipe: "/cms/api/recipes",
          labels: "/public/cms/api/labels",
          languages: "/public/cms/api/i18n/locales",
          user: "/cms/api/users",
          categories: "/cms/api/categories",
          publicUsers: "/public/cms/api/users",
          storage: "/cms/api/users",
          products: "/ecomm/store/products",
          me: "/cms/api/users/me",
          usersUpdate: "/cms/api/users",
          ingredients: "/cms/api/ingredients",
          features: "/cms/api/features",
          achievements: "/cms/api/achievements",
          ticket:"/crm/api/v1/tickets/",
          activity: "/cms/api/histories",
          appliances: "/cms/api/appliances",
          seotags: "/cms/api/seotags",
          faqs: "/cms/api/articles"
        }
      },
    },
    prod: {
      api: {
        hostname: "https://tkofapim.azure-api.net",
        clientId: "dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2",
        scope: "openid dcc8ca4a-42ce-4da8-90a1-2bfc2ad0feb2  profile",
        personalLoginUrl: "https://thekitchenofthefuture.b2clogin.com/thekitchenofthefuture.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_ROPC",
        subscriptionkey: "964bf762168d4403a69040dc14858380",
        base: {
          recipe: "/cms/api/recipes",
          labels: "/public/cms/api/labels",
          languages: "/public/cms/api/i18n/locales",
          user: "/cms/api/users",
          categories: "/cms/api/categories",
          publicUsers: "/public/cms/api/users",
          storage: "/cms/api/users",
          products: "/ecomm/store/products",
          singleRecipe: "/cms/api/recipes",
          ticket:"/crm/api/v1/tickets",
          appliances: "/cms/api/appliances",
          activity: "/cms/api/histories",
          faqs: "/cms/api/articles"
        }
      },
    }
  },
  env() {
    return this.environment[this.currentEnv];
  },
 headers(accesstoken) {
   return {
      'Ocp-Apim-Subscription-Key': this.env().api.subscriptionkey,
      'Authorization': `Bearer ${accesstoken}`,
    };
  },
  subscriptionKey() {
   return {
      'Ocp-Apim-Subscription-Key': this.env().api.subscriptionkey,
    };
  },
  url(type) {
    return this.env().api.hostname + this.env().api.base[type];
  },

}
